<template>
  <div>
    <v-autocomplete v-model="model" :items="data" :label="label" :loading="loading" :search-input.sync="search"
      :return-object="returnObject" cache-items :filter="filterItem" :rules="rules" clearable item-value="id" item-text="text"
      :multiple="multi" color="primary" placeholder="Start typing to Search" class="input">
      <template slot="selection" slot-scope="data">
        <v-chip :selected="data.selected" close class="chip--select-multi" @input="remove(data.item.id)">
          <v-avatar>
            <img :src="api.GET_IMAGE(data.item.profile_image)" />
          </v-avatar>
          {{ data.item.first_name + " " + data.item.last_name }}
        </v-chip>
      </template>
      <template slot="item" slot-scope="data">
        <v-list-tile-avatar>
          <img :src="api.GET_IMAGE(data.item.profile_image)" />
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title v-html="data.item.first_name + ' ' + data.item.last_name"></v-list-tile-title>
          <v-list-tile-sub-title v-html="data.item.username"></v-list-tile-sub-title>
        </v-list-tile-content>
      </template>
      <v-slide-x-reverse-transition slot="append-outer" mode="out-in">
        <v-icon :key="`icon-${isEditing}`" :color="isEditing ? 'success' : 'info'" @click="isEditing = !isEditing"
          v-text="isEditing ? 'mdi-check-outline' : 'mdi-circle-edit-outline'"></v-icon>
      </v-slide-x-reverse-transition>
    </v-autocomplete>
  </div>
</template>
<script>

import axios from "axios";
let CancelToken = axios.CancelToken;
let cancel;
export default {
  name: "choose-captains-multi",
  props: {
    label: {},
    // The v-model value. The picker follows it: when the parent clears it
    // (a dialog reset) the chip is cleared too, and an id or captain object
    // set by the parent is selected. Left undefined (no v-model), the picker
    // keeps its own selection as before.
    value: {
      default: undefined,
    },
    url: {
      type: String,
      default() {
        return "captain/search";
      },
    },
    initialSearchParams: {
      type: URLSearchParams,
      default: () => new URLSearchParams(),
    },
    multi: {
      type: Boolean,
      default: true,
    },
    returnObject: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isEditing: false,
      loading: false,
      model: this.multi ? [] : null,
      search: null,
      data: [],
      cached: [],
      lastResultIds: [],
    };
  },

  watch: {
    // Declared before `model`, so the immediate run seeds the selection
    // without echoing an input event back to the parent.
    value: {
      immediate: true,
      handler(val) {
        if (val === undefined) return
        if (this.sameSelection(val, this.model)) return

        if (this.isEmptySelection(val)) {
          this.model = this.multi ? [] : null
          return
        }

        // A full captain object passed by the parent must be in the items,
        // or the autocomplete cannot render its chip.
        const values = Array.isArray(val) ? val : [val]
        values.forEach((item) => {
          if (item && typeof item === "object" && item.id !== undefined) {
            this.rememberItem(item)
          }
        })

        this.model = this.multi ? (Array.isArray(val) ? val.slice() : [val]) : val
      },
    },

    search(val) {
      if (!val) return
      if (cancel) cancel();
      this.loading = true
      const params = new URLSearchParams(this.initialSearchParams)
      params.append("search", val)
      this.axios
        .get(this.url, {
          params: params,
          cancelToken: new CancelToken(function executor(c) {
            cancel = c; // c is the cancel function
          }),
        })
        .then((res) => {
          const { data } = res.data
          this.lastResultIds = (data || []).map((item) => item.id)
          this.data = (data || []).map((item) => ({
            // Name, phone (username), email, id and GL leaf code: the backend
            // also matches the id and the driver's account code.
            text: [
              item.first_name,
              item.last_name,
              item.username,
              item.whatsapp_number,
              item.email,
              item.id,
              item.gl_account_code,
            ]
              .filter((part) => part !== null && part !== undefined && part !== "")
              .join(" "),
            ...item,
          }))
          // Every row seen so far, so a selection can always be resolved to
          // its full captain object.
          this.cached = this.data
            .concat(this.cached.filter((old) => this.lastResultIds.indexOf(old.id) === -1))
            .slice(0, 200)
        })
        .catch((err) => {
          if (axios.isCancel(err)) return
          // Accountant doc 2026-10-03 item 1.1: a 403 used to look like
          // "no drivers"; say what happened instead.
          const message =
            (err && err.response && err.response.data && err.response.data.message) ||
            this.$t("shared.captainSearchFailed")
          if (window.getApp) window.getApp.$emit("SHOW_TOAST", message, "red")
        })
        .finally(() => (this.loading = false))
    },

    model(val) {
      // Emit to parent
      this.$emit("input", val)
      // The full captain row(s) (incl. gl_account_id / gl_account_code) for
      // parents that need more than the id.
      this.$emit("selected", this.selectedItems(val))
    },

    // value: {
    //   handler(val) {
    //     // Keep data consistent only when full objects are passed
    //     if (!val) {
    //       this.model = null
    //       return
    //     }

    //     if (this.multi) {
    //       // multi-select mode
    //       if (Array.isArray(val)) {
    //         const fullObjects = val.filter(v => typeof v === 'object' && v !== null)
    //         // merge unique full objects only
    //         fullObjects.forEach(v => {
    //           if (!this.data.some(item => item.id === v.id)) {
    //             this.data.push(v)
    //           }
    //         })
    //       }
    //     } else {
    //       // single select mode
    //       if (typeof val === 'object' && val !== null) {
    //         if (!this.data.some(item => item.id === val.id)) {
    //           this.data.push(val)
    //         }
    //       }
    //     }

    //     this.model = val
    //   },
    //   deep: true,
    // },
  },

  methods: {
    // The server already filtered (by phone with any prefix, id, leaf
    // code...), so its latest rows always stay visible; cached rows from
    // earlier searches fall back to a plain text match.
    filterItem(item, queryText, itemText) {
      if (this.lastResultIds.indexOf(item.id) !== -1) return true
      return String(itemText || "")
        .toLowerCase()
        .indexOf(String(queryText || "").toLowerCase()) > -1
    },
    selectedItems(val) {
      const pick = (value) => {
        if (value && typeof value === "object") return value.id !== undefined ? value : null
        return this.cached.find((item) => item.id === value) || null
      }
      if (this.multi) {
        return (Array.isArray(val) ? val : []).map(pick).filter((item) => item)
      }
      return pick(val)
    },
    selectionIds(val) {
      const list = Array.isArray(val) ? val : [val]
      return list
        .filter((item) => !this.isEmptySelection(item))
        .map((item) => (item && typeof item === "object" ? item.id : item))
    },
    isEmptySelection(val) {
      if (val === null || val === undefined || val === "") return true
      if (Array.isArray(val)) return val.length === 0
      // The old single-mode default was {}: an object with no id is empty.
      if (typeof val === "object") return val.id === undefined || val.id === null
      return false
    },
    sameSelection(a, b) {
      return JSON.stringify(this.selectionIds(a)) === JSON.stringify(this.selectionIds(b))
    },
    rememberItem(item) {
      if (this.data.some((existing) => existing.id === item.id)) return
      const text = [item.first_name, item.last_name, item.username, item.id]
        .filter((part) => part !== null && part !== undefined && part !== "")
        .join(" ")
      const row = { text, ...item }
      this.data = this.data.concat([row])
      if (!this.cached.some((existing) => existing.id === item.id)) {
        this.cached = [row].concat(this.cached).slice(0, 200)
      }
    },
    remove(id) {
      if (!!this.multi) this.model = this.model.filter((item) => item !== id);
      else this.model = null;
    },
  },
};
</script>

<style scoped></style>